import TextProperties from '../abstract/text/text-properties';

export default class ParagraphProperties extends TextProperties {
  render() {
    return super.render('textarea', true);
  }
}
